/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListBindingsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListBindingsRequest = {
  principalId: string;
  userSessionIssuerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListBindingsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListBindingsSecurity$outboundSchema: z.ZodMiniType<
  ListBindingsSecurity$Outbound,
  ListBindingsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listBindingsSecurityToJSON(
  listBindingsSecurity: ListBindingsSecurity,
): string {
  return JSON.stringify(
    ListBindingsSecurity$outboundSchema.parse(listBindingsSecurity),
  );
}

/** @internal */
export type ListBindingsRequest$Outbound = {
  principal_id: string;
  user_session_issuer_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListBindingsRequest$outboundSchema: z.ZodMiniType<
  ListBindingsRequest$Outbound,
  ListBindingsRequest
> = z.pipe(
  z.object({
    principalId: z.string(),
    userSessionIssuerId: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalId: "principal_id",
      userSessionIssuerId: "user_session_issuer_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listBindingsRequestToJSON(
  listBindingsRequest: ListBindingsRequest,
): string {
  return JSON.stringify(
    ListBindingsRequest$outboundSchema.parse(listBindingsRequest),
  );
}
